import React from "react";
import styled from "styled-components";
import logo from "../Asset/Icons/logo.png";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 2000;
  margin-bottom: 30px;
`;

const LogoBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  width: 50%;
`;

const Vision = styled.div`
  font-size: 14px;
  font-family: GmarketSansMedium;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
`;

const TextArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
`;

const Introduce = () => {
  return (
    <Box className="disableDrag">
      <LogoBox>
        <Logo src={logo}></Logo>
      </LogoBox>
      <Vision>귀여움을 큐레이션 합니다!</Vision>
      <TextArea>
        귀여운 걸 보면 스트레스가 풀린다는 연구 결과는 찾지 못했어요.<br></br>
        하지만 저희는 그걸 본능적으로 알고 있죠.<br></br>
        <br></br>일상에 지친 당신을 위해 귀염둥이들을 모아왔어요.<br></br>
        귀염뽀짝한 친구들로 심신을 달래 볼래요?
      </TextArea>
    </Box>
  );
};

export default Introduce;
